// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__-k8ez","row":"Layout_row__R8Az+","col":"Layout_col__xQbrZ"};